<template>
  <b-card
    v-if="data"
    class="card-tiny-line-stats dash-total-card"
    body-class="p-250"
  >
    <div class="card-title">Total No. Of New Clients</div>
    <b-row>
      <b-col class="dash-card-score">
        <h1 class="font-weight-bolder mb-0 card-value">
          87
        </h1>
        <div class="card-bottom" style="color: #F65160;">Increased +3</div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    BCard,
    VueApexCharts,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    }
  },
}
</script>
